<template>
  <v-container>
    <v-row justify="center">
      <v-dialog v-model="dialog" max-width="350">
        <v-card>
          <v-card-title class="headline">Freigabe ablehnen</v-card-title>

          <v-card-text> Willst du die Freigabe wirklich ablehnen? </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn tile color="grey darken-1" text @click="cancel()"> Abbrechen </v-btn>

            <v-btn tile color="red darken-1" text @click="onRejectClick()"> Ablehnen </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar v-model="showError" color="error" y="top" :timeout="timeout">
      {{ 'Es ist ein  Fehler aufgetreten' }}
    </v-snackbar>
    <v-snackbar v-model="showSuccess" color="success" y="top" :timeout="timeout">
      {{ 'Die Freigabe wurde erfolgreich abgelehnt' }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { API } from 'aws-amplify';
import * as mutations from '@/graphql/mutations';

export default {
  data: () => ({
    dialog: false,
    showError: false,
    showSuccess: false,
    responseObj: null,
    timeout: 3000,
    id: null,
    _version: null,
    items: {},
    userRole: null,
  }),
  computed: {},
  methods: {
    onRejectClick() {
      this.rejectItemById(this.id, this._version, this.mutation, this.items).then(() => {
        this.dialog = false;
        this.$emit('itemRejected', { id: this.id, handled: 3, active: false });
        this.$emit('refresh');
      });
    },
    async rejectItemById(id, _version, mutationName) {
      const inputObj = {
        id,
        _version,
        active: false,
        handled: 3,
      };
      
      if (this.userRole === 'manager') {
        inputObj.manager_reject = new Date().toISOString();
      } else if (this.userRole === 'controller') {
        inputObj.controller_reject = new Date().toISOString();
      }
      
      await API.graphql({ query: mutations[mutationName], variables: { input: inputObj } });
    },
    show(items, id, _version, mutation, userRole) {
      this.dialog = true;
      this.id = id;
      this.items = items;
      this.mutation = mutation;
      this._version = _version;
      this.userRole = userRole;
    },
    cancel() {
      this.dialog = false;
      this.$emit('dialogClose');
    },
  },
};
</script>